import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #ececec;
  margin-top: 8px;
  padding: 20.5px 16px 20.5px 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
`;

export const Cell: any = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 0 48px 0 0;
`;

export const CellDate: any = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const CellSmall: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 50px;
`;

export const CellText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #424248;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  width: 200px;
  align-items: center;
`;
